import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const FORM_ENDPOINTS = {
  detail: (id) => `${BASE_URL}api/forms/${id}/`,
  unsubscribe: (id) => `${BASE_URL}api/forms/unsubscribe/${id}/`,
};

class Form {
  async fetchForm(id) {
    return await request({
      url: FORM_ENDPOINTS.detail(id),
    });
  }

  async saveAnswers(id, answers) {
    const { data } = await request({
      url: FORM_ENDPOINTS.detail(id),
      method: "POST",
      body: answers,
    });
    return data;
  }

  async unsubscribe(id) {
    return await request({
      url: FORM_ENDPOINTS.unsubscribe(id),
      method: "POST",
    });
  }
}

export const FormService = new Form();
